import React, { lazy } from "react";
import { CslDetailsSections } from "../../../@types/enums/csl-details-sections/CslDetailsSections";
import { Loader } from "../../root/loader";
const CslDetailsPage = lazy(() => import("./"));

export const csldetails = () => [
    {
        target: "$ONE_LAYOUT_ROUTE",
        handler: {
            exact: true,
            path: `/csl/:workspaceId/details/:cslId/${CslDetailsSections.Registry}`,
            element: (
                <Loader>
                    <CslDetailsPage section={CslDetailsSections.Registry} />
                </Loader>
            )
        }
    },
    {
        target: "$ONE_LAYOUT_ROUTE",
        handler: {
            exact: true,
            path: `/csl/:workspaceId/details/:cslId/${CslDetailsSections.Offices}`,
            element: (
                <Loader>
                    <CslDetailsPage section={CslDetailsSections.Offices} />
                </Loader>
            )
        }
    },
    {
        target: "$ONE_LAYOUT_ROUTE",
        handler: {
            exact: true,
            path: `/csl/:workspaceId/details/:cslId/${CslDetailsSections.Banks}`,
            element: (
                <Loader>
                    <CslDetailsPage section={CslDetailsSections.Banks} />
                </Loader>
            )
        }
    },
    {
        target: "$ONE_LAYOUT_ROUTE",
        handler: {
            exact: true,
            path: `/csl/:workspaceId/details/:cslId/${CslDetailsSections.PaymentModes}`,
            element: (
                <Loader>
                    <CslDetailsPage section={CslDetailsSections.PaymentModes} />
                </Loader>
            )
        }
    },
    {
        target: "$ONE_LAYOUT_ROUTE",
        handler: {
            exact: true,
            path: `/csl/:workspaceId/details/:cslId/${CslDetailsSections.Contacts}`,
            element: (
                <Loader>
                    <CslDetailsPage section={CslDetailsSections.Contacts} />
                </Loader>
            )
        }
    }
];
